import script from "./AddNumberTelegramDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AddNumberTelegramDialog.vue?vue&type=script&setup=true&lang=js"

import "./AddNumberTelegramDialog.vue?vue&type=style&index=0&id=b2f149b4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2f149b4"]])

export default __exports__